import { render, staticRenderFns } from "./CreateInquiry.vue?vue&type=template&id=27a5b141"
import script from "./CreateInquiry.vue?vue&type=script&lang=js"
export * from "./CreateInquiry.vue?vue&type=script&lang=js"
import style0 from "./CreateInquiry.vue?vue&type=style&index=0&id=27a5b141&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports